export default __webpack_public_path__ + "static/media/ficon-2.864dba28.svg";